export const COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export const COOKIE_ARTICLE_AUTH_KEY = 'articlesAuthTokenV2'
